import { t } from 'i18next';
import * as yup from 'yup';

export const vendorQuoteLogSchema = () =>
  yup.object({
    dateFrom: yup.mixed().nullable().label(t('labelDateFrom')),
    dateTo: yup.mixed().nullable().label(t('labelDateTo')),
  });
